// src/features/home/components/SocialLinks.tsx

import React from 'react';
import styles from './SocialLinks.module.scss';
import { FaGithub, FaLinkedin, FaInstagram } from 'react-icons/fa';
import { SiUpwork } from 'react-icons/si';

const SocialLinks: React.FC = () => {
  return (
    <div className={styles.socialLinks}>
      <ul>
        <li>
          <a
            href="https://linkedin.com/in/jamiljoo"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedin />
          </a>
        </li>
        <li>
          <a 
          href="https://instagram.com/jamil_joo"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          >
            <FaInstagram />
          </a>
        </li>
        <li>
          <a 
          href="https://www.upwork.com/freelancers/~011243a6d19af75131"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Upwork"
          >
            <SiUpwork />
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialLinks;
